import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';
import {
  OrganizationListItem,
  ORGANIZATIONS_QUERY_KEY,
  OrganizationsApiResponse,
} from './types';

export type { OrganizationListItem, ResponseDataProps } from './types';

export const useGetOrganizationCollectionEndpoint = (
  options?: UseQueryOptions<OrganizationListItem[], AxiosError>,
): UseQueryResult<OrganizationListItem[], AxiosError> => useQuery<OrganizationListItem[], AxiosError>({
  queryKey: ORGANIZATIONS_QUERY_KEY,
  queryFn: async (): Promise<OrganizationListItem[]> => {
    const res = await axiosInstance.get<OrganizationsApiResponse<OrganizationListItem[]>>(
      '/v3-getOrganizationsCollection',
    );
    const data = res.data?.data;
    if (!Array.isArray(data)) {
      throw new Error('Nieoczekiwany kształt odpowiedzi /v3-getOrganizationsCollection');
    }
    return data;
  },
  retry: (failureCount, error) => {
    const status = error?.response?.status;
    if (status && status >= 400 && status < 500) return false;
    return failureCount < 3;
  },
  retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
  staleTime: 1000 * 60 * 5,
  refetchOnWindowFocus: false,
  ...options,
});
